export default __webpack_public_path__ + "static/media/download.ee240337.svg";